<template>
  <div class="col-12 u-marg-t-ml">
    <!-- IF PLAN IS PRE-SELECTED -->
    <p class="t-h2--md c-product-capacity-text ordered-props"><span class="n-label n-label--black">3</span> <span>{{ $t('Choose a plan') }}{{ setSpace() }}:</span> <span class="u-grey-text">{{ currentProduct.plan.name }}</span></p>

    <div class="switch" v-if="maxDiscount > 0">
      <div class="switch-control-custom gtm-section-engagement-choice js-switch-fiber my-3">
        <input
          type="checkbox"
          id="phoneWithFiber"
          name="phoneDiscount"
          class="switch-input-custom input-offer"
          v-model="switchStatus"
          @click="changeParam('livebox_prices', switchStatus)">
          <label class="switch-label-custom" for="phoneWithFiber">
            <div class="switch-toggle-custom" id="fiber-switch-toggle"></div>
            <div class="switch-content-custom">
              <div class="info-box">
                <span>{{ $t('Livebox subscriber prices')}}</span>
              </div>
              <div class="fw-normal">{{ discountText }}</div>
            </div>
          </label>
      </div>
    </div>

    <div v-if="selectedPlan" class="mt-3">
      <PlanItem
        :is-plan-selected-from-url="selectedPlan"
        :data="plans[currentIndex]"
        :switch="switchStatus"/>
        <div class="c-plan-card-big__details u-center u-pad-t-xs u-pad-b-xs u-pad-b-0--sm gtm-section-cta-all-subscriptions o-link-arrow">
          <span
            @click="openOtherPlans"
            class="u-bold"
          >
            {{ $t('See other plans') }}
          </span>
        </div>
    </div>
    <!-- <div v-if="selectedPlan">
        <p class="t-h2">{{ $t('My offer') }}</p>
        <div class="row">
            <div class="col-12 col-sm-6 u-marg-t-sm">
                <PlanCard
                  :is-plan-selected-from-url="selectedPlan"
                  :data="plans[0]" />
                  <div class="c-plan-card-big__details u-center u-pad-t-xs u-pad-b-xs u-pad-b-0--sm gtm-section-cta-all-subscriptions o-link-arrow">
                      <span
                        @click="openOtherPlans"
                        class="u-bold"
                      >
                        {{ $t('See other plans') }}
                      </span>
                  </div>
            </div>
        </div>
    </div> -->

    <!-- IF WANT MORE PLANS (PLANS SLIDER) -->
    <div v-if="!selectedPlan" class="mt-3">
      <!-- <p class="t-h2 c-product-capacity-text ordered-props"><span class="n-label n-label--black">3</span> <span>{{ $t('Mobile plan') }}:</span> <span>{{ currentProduct.plan.name }}</span></p> -->
          <PlanItem
            v-for="(plan, index) in plans"
            :index="index"
            :key="plan.option_id + '-' + index"
            :data="plan"
            :isAnyPromo="isAnyPromo"
            :switch="switchStatus"
            @openPlan="openPlan"
            @selectPlan="selectPlan" />
    </div>
    <!-- <div v-if="!selectedPlan">
        <p class="t-h2 c-product-capacity-text">{{ $t('Mobile plan') }}</p>
        <div ref="jsSlider" class="c-plan-slider slider slider--same-height-cells u-marg-t-xxs" data-align="center" data-dots="true">
          <PlanCard
            v-for="(plan, index) in plans"
            :index="index"
            :key="plan.option_id + '-' + index"
            :data="plan"
            @slide="slide" />
        </div>
    </div> -->
  </div>
</template>

<script>
import PlanCard from './PlanCard'
import PlanItem from './PlanItem'
import MixinAddToCart from "./Mixins/MixinAddToCart";
import { AddSpaceFr } from "./Mixins/CustomOptionsMixins";

import GetData from '~src/static/olu/colorz/utils/getData'

import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    isPlanSelectedFromUrl: {
      type: Boolean,
      default: () => false
    }
  },
  components: {
    PlanCard,
    PlanItem
  },
  data () {
    return {
      currentPlan: {},
      selectedPlan: false,
      plans: [],
      currentIndex: 0,
      switchStatus: null,
      maxDiscount: 1
    }
  },
  computed: {
    ...mapGetters({
      currentProduct: 'GET_CURRENT_PRODUCT',
      productInformations: 'GET_PRODUCT_INFORMATIONS',
      $t: 'GET_TRAD'
    }),
    discountText(){
      let allDiscounts = this.currentProduct.availablePlans.map(e => e.subscription_convergent_discount ? +e.subscription_convergent_discount : 0)
      let maxDiscount = Math.max(...allDiscounts)
      this.maxDiscount = maxDiscount
      return `${this.$t('Save up to €%1/month').replace('%1', maxDiscount)}`
    },
    isAnyPromo(){
      let tempArray = this.plans.filter(e => {
        // return !!e.custom_label && e.custom_label.length
        let startDate
        let endDate
        if (e.promo_date_start_1 || e.promo_date_end_1) {
            startDate = e.promo_date_start_1;
            endDate = e.promo_date_end_1;
        } else {
            return !!e.custom_label && e.custom_label.length;
        }

        let timezone = e.timezone_config;
        var now = new Date();
        var currentTime = now.toLocaleString('sv-SE', {timeZone: timezone});

        return (!!e.custom_label && e.custom_label.length) || startDate <= currentTime && endDate >= currentTime
      })
      return !!tempArray.length
    }
  },
  beforeMount () {
    this.selectedPlan = this.isPlanSelectedFromUrl
    this.plans = this.currentProduct.availablePlans
    this.addInstalmentToPlan()
    const urlParams = new URLSearchParams(window.location.search);
    const fromPlan = urlParams.get('fromPlan');
    if(fromPlan){
      this.currentIndex = this.plans.findIndex(e => e.sku === fromPlan)
    }
  },
  mounted () {
    this.getParams()
    this.selectPlan(this.currentIndex)
    this.openPlan(this.currentIndex)
    // console.log(' this.currentProduct',  this.currentProduct)
    // if jsSlider is available in the DOM it means the user didn't choose his plan before
    // so we initialise the slider with the differents plans available
    if (this.$refs.jsSlider) {
      this.createSlider()
    }
  },
  watch: {
    'currentProduct.availablePlans': {
      handler (newAvailablePlans, oldAvailablePlans) {
        if (newAvailablePlans[0].option_id !== oldAvailablePlans[0].option_id) {
          let product = {...this.currentProduct}
          // Change plans only if jsSlider is available
          if (this.$refs.jsSlider) {
            // Remove Flickity functionality completely. destroy will return the element back to its pre-initialized state.
            this.flick.destroy()

            // Update with the new data
            this.plans = product.availablePlans
            this.addInstalmentToPlan()

            // Initiate new flickity AFTER the dom has been updated by vuejs
            this.$nextTick(() => {
              this.createSlider()
            })
          } else {
            // Only Update with the new data if we have a plan in the url
            this.plans = product.availablePlans
            // product.plan = this.plans[0]
            this.addInstalmentToPlan()

            this.setCurrentProduct({currentProduct: product})

          }
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({
      setCurrentProduct: 'SET_CURRENT_PRODUCT',
      setOpenProduct: 'SET_OPEN_PRODUCT'
    }),
    setSpace(){
      return AddSpaceFr(this.productInformations)
    },
    async openOtherPlans () {
      this.selectedPlan = false
      // wait for the dom to be updated
      await this.$nextTick()
      this.createSlider()
    },
    getParams(){
      setTimeout(() => {
          let queryParam = new URLSearchParams(window.location.search);
          let liveboxPrices = queryParam.get('livebox_prices');
          let localStorageStatus = localStorage.getItem('is_enable_livebox_for_plan');

          switch (liveboxPrices) {
              case '1':
                  this.switchStatus = 1;
                  localStorage.setItem('is_enable_livebox_for_plan', 1);
                  document.cookie = "is_enable_livebox_for_plan=1; path=/";
                  break;

              case '0':
                  this.switchStatus = 0;
                  localStorage.setItem('is_enable_livebox_for_plan', 0);
                  document.cookie = "is_enable_livebox_for_plan=0; path=/";
                  break;

              default:
                  switch (localStorageStatus) {
                      case '1':
                          this.switchStatus = 1;
                          // this.setParam('livebox_prices', 1);
                          break;

                      case '0':
                          this.switchStatus = 0;
                          // this.setParam('livebox_prices', 0);
                          break;

                      default:
                          this.switchStatus = 0;
                          // this.setParam('livebox_prices', 0);
                          break;
                  }
                  break;
          }
      });
    },
    setParam(param, value){
      let queryParam = new URLSearchParams(window.location.search);
      queryParam.set(param, value);
      if(!value){
        queryParam.delete(param);
      }
      history.replaceState(null, null, !!queryParam.toString() ? "?" + queryParam.toString() : '');
    },
    changeParam (param, value) {
      let tempValue

      !!value ? tempValue = 0 : tempValue = 1

      let queryParam = new URLSearchParams(window.location.search);
      queryParam.set(param, tempValue);
        localStorage.setItem('is_enable_livebox_for_plan', tempValue);
        document.cookie = "is_enable_livebox_for_plan=" + tempValue + "; path=/";
        this.showLiveboxAdvantage();
      history.replaceState(null, null, !!queryParam.toString() ? "?" + queryParam.toString() : '');
      this.selectPlan(this.currentIndex)
    },
    updateMagentoPlan () {
      const plan = document.querySelector(`[name="options[${this.currentProduct.plan.option_id}]"][value="${this.currentProduct.plan.option_value}"]`)

      if (plan) {
        plan.checked = true
      }
    },
    addInstalmentToPlan () {
      let instalments = this.productInformations.instalments[this.currentProduct.sku]
      if (instalments && instalments.totalRecords > 0) {
        // let firstPlan = this.plans.shift()
        // this.plans = [firstPlan, ...this.plans.sort((a, b) => +a.monthly_price - +b.monthly_price).reverse()]
        this.plans = this.plans.map(plan => {
          const currentInstalment = instalments.items.find(instalment => plan.sku === instalment.device_plan_sku)
          if (currentInstalment) {
            return {
              ...currentInstalment,
              ...plan
            }
          } else {
            return plan
          }
        })
      }

      /**
       * If we have a plan selected, we add the instalment in the global state too
       */
      if (this.isPlanSelectedFromUrl) {
        let product = { ...this.currentProduct }
        // product.plan = this.plans.filter(e => e.sku === )
        product.plan  = this.plans[this.currentIndex]
        this.setCurrentProduct({ currentProduct: product })
      }
      // else{
      //   this.plans = this.plans.sort((a, b) => +a.monthly_price - +b.monthly_price).reverse()
      // }
      // this.setParam('fromPlan', this.plans[0].sku)
    },
    openPlan(planIndex){
      let product = {...this.currentProduct}

      product.plan = this.plans[planIndex]
      this.setOpenProduct({openProduct: product})
    },
    selectPlan (planIndex) {
      this.currentIndex = planIndex
      // Clone this.currentProduct
      // Update this.product if something has changed in the global state
      let product = {...this.currentProduct}
      let productInformations = {...this.productInformations}

      product.plan = this.plans[planIndex]
      product.device_plan_sku = this.plans[planIndex].sku
      product.currentPlanIndex = planIndex

      for (let instalment in productInformations.instalments) {
        if (instalment === product.sku) {
          if (product.device_plan_sku && product.device_plan_sku.length > 0) {
            product.instalment = productInformations.instalments[instalment].items.find(item => item.device_plan_sku === product.device_plan_sku)
          } else {
            // if device_plan_sku is empty it means the user have selected the mobile only plan
            // so we reset the current instalment
            product.instalment = {}
          }
        }
      }

      // this.setParam('fromPlan',  product.plan.sku)

      this.setCurrentProduct({currentProduct: product})

      this.updateMagentoPlan()

    },
    createSlider () {
      const slider = this.$refs.jsSlider

      const align = GetData(slider, 'align') == null ? 'left' : GetData(slider, 'align')
      const dots = GetData(slider, 'dots') == null ? false : GetData(slider, 'dots')
      const wrapAround = GetData(slider, 'infinite') == null ? true : GetData(slider, 'infinite')

      const Flickity = window.Flickity

      const self = this

      this.flick = new Flickity(slider, {
        cellSelector: '.js-slider-item',
        cellAlign: align,
        contain: true,
        pageDots: false,
        wrapAround: false,
        prevNextButtons: false,
        lazyLoad: true,
        watchCSS: true,
        selectedAttraction: 0.1,
        friction: 1,
        imagesLoaded: true,
        on: {
          change: (index) => {
            self.selectPlan(index)
          }
        }
      })
      // FIX IOS 15 : https://github.com/metafizzy/flickity/issues/1177#issuecomment-964056241
      this.flick.on( 'dragStart', () => {
        document.ontouchmove = (e) => {
          e.preventDefault();
         return  false
        }
      })
      this.flick.on( 'dragEnd', () => {
        document.ontouchmove = () => true
      })
    },
    // createSlider () {
    //   const slider = this.$refs.jsSlider

    //   const align = GetData(slider, 'align') == null ? 'left' : GetData(slider, 'align')
    //   const dots = GetData(slider, 'dots') == null ? false : GetData(slider, 'dots')
    //   const wrapAround = GetData(slider, 'infinite') == null ? true : GetData(slider, 'infinite')

    //   const Flickity = window.Flickity

    //   const self = this

    //   this.flick = new Flickity(slider, {
    //     cellSelector: '.js-slider-item',
    //     cellAlign: align,
    //     contain: true,
    //     pageDots: dots,
    //     wrapAround: wrapAround,
    //     prevNextButtons: true,
    //     arrowShape: 'M 10,50 L 50,90 L 55,85 L 20,50  L 55,15 L 50,10 Z',
    //     lazyLoad: true,
    //     watchCSS: true,
    //     selectedAttraction: 0.1,
    //     friction: 1,
    //     imagesLoaded: true,
    //     on: {
    //       change: (index) => {
    //         self.selectPlan(index)
    //       },
    //       ready: () => {
    //         self.selectPlan(0)
    //       }
    //     }
    //   })
    //   // FIX IOS 15 : https://github.com/metafizzy/flickity/issues/1177#issuecomment-964056241
    //   this.flick.on( 'dragStart', () => {
    //     document.ontouchmove = (e) => {
    //       e.preventDefault();
    //      return  false
    //     }
    //   })
    //   this.flick.on( 'dragEnd', () => {
    //     document.ontouchmove = () => true
    //   })
    // },
    slide (slideIndex) {
      let currentIndex = this.currentProduct.currentPlanIndex;
      let maxIndex = this.currentProduct.availablePlans.length - 1;
      let destinationIndex = slideIndex;

      if (this.flick) {
        // si c'est le prochain item on next
        if ((currentIndex + 1 === destinationIndex) || (destinationIndex === 0 && currentIndex === maxIndex)) {
          this.flick.next();
        } else if ((currentIndex - 1 === destinationIndex) || (currentIndex === 0 && destinationIndex === maxIndex)) {
          this.flick.previous();
        }
      }
    }
  },
    mixins: [MixinAddToCart]
}
</script>

